<template>
    <v-menu transition="slide-y-transition" bottom offset-y z-index="140">
        <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
                <v-icon>fas fa-location-arrow</v-icon>
            </v-btn>
        </template>

        <v-list class="overflow-y-auto" color="#008075" dark max-height="400px">
            <v-list-item v-for="objetoSig in objetosSig" :key="objetoSig.id_sig_objeto" @click="actualizarPosicion(objetoSig.posicion)">
                <v-list-item-title>{{ objetoSig.nombre }}</v-list-item-title>
            </v-list-item>
        </v-list>
    </v-menu>
</template>

<script>
export default {
    computed: {
        objetosSig() {
            return this.$store.state.navegacionSig.objetosSig;
        }
    },
    methods: {
        actualizarPosicion(posicionObjeto) {
            this.$store.commit("navegacionSig/actualizarPosicion", posicionObjeto);
        }
    }
}
</script>